import Repository from "@/app/repository/repository-factory";

const ReleaseInfoRepository = Repository.get("ReleaseInfoRepository");

const STORAGE_KEYS = {
  apiReleaseInfo: "api_release_info",
};

const apiReleaseInfo = JSON.parse(localStorage.getItem(STORAGE_KEYS.apiReleaseInfo));
let apiReleaseInfoRequest = null;

const state = {
  apiReleaseInfo: apiReleaseInfo || null,
  apiReleaseInfoLoaded: false,
  apiReleaseInfoLoading: false,
};

const actions = {
  loadApiReleaseInfo({ commit }) {
    if (!localStorage.getItem("token")) {
      commit("clearApiReleaseInfo");
      return Promise.resolve(null);
    }

    if (apiReleaseInfoRequest) {
      return apiReleaseInfoRequest;
    }

    commit("apiReleaseInfoRequest");

    apiReleaseInfoRequest = ReleaseInfoRepository.getCoreReleaseInfo()
      .then(response => {
        const releaseInfo = response && response.data ? response.data : null;
        commit("apiReleaseInfoSuccess", releaseInfo);
        return releaseInfo;
      })
      .catch(() => {
        commit("apiReleaseInfoFailure");
        return null;
      })
      .finally(() => {
        apiReleaseInfoRequest = null;
      });

    return apiReleaseInfoRequest;
  },
  clearApiReleaseInfo({ commit }) {
    commit("clearApiReleaseInfo");
  },
};

const mutations = {
  apiReleaseInfoRequest(state) {
    state.apiReleaseInfoLoading = true;
  },
  apiReleaseInfoSuccess(state, releaseInfo) {
    state.apiReleaseInfo = releaseInfo;
    state.apiReleaseInfoLoaded = true;
    state.apiReleaseInfoLoading = false;
    localStorage.setItem(STORAGE_KEYS.apiReleaseInfo, JSON.stringify(releaseInfo || null));
  },
  apiReleaseInfoFailure(state) {
    state.apiReleaseInfoLoaded = true;
    state.apiReleaseInfoLoading = false;
  },
  clearApiReleaseInfo(state) {
    state.apiReleaseInfo = null;
    state.apiReleaseInfoLoaded = false;
    state.apiReleaseInfoLoading = false;
    localStorage.removeItem(STORAGE_KEYS.apiReleaseInfo);
  },
};

export const releaseInfo = {
  namespaced: true,
  state,
  actions,
  mutations,
};
